import _ from 'lodash';

type DataArray = $TSFixMe[];

// All rows must have an id field
// Generalize data for the table data so as to handle sorting, selecting and filtering easily
// TODO: handle local delete and insert so we don't have to create the the datalist every time change happens
class DataList<T extends {}> {
  declare _size: number;

  declare _allIndexes: number[];

  declare _indexMap: number[];

  declare _cache: T[];

  constructor(dataArray: DataArray = []) {
    const localDataArray = this._parseData(dataArray);

    this._size = localDataArray.length;
    this._allIndexes = _.range(localDataArray.length);
    // The indexMap is used to map the filtering and sorting
    this._indexMap = this._allIndexes.slice();
    this._cache = localDataArray;
  }

  _isValidIndex(index: number) {
    return index >= 0 && index < this._size;
  }

  updateCache(dataArray: DataArray) {
    const localDataArray = this._parseData(dataArray);

    this._allIndexes = _.range(localDataArray.length);
    this._indexMap = this._allIndexes.slice();
    this._size = localDataArray.length;
  }

  _parseData(dataArray: DataArray) {
    return dataArray;
  }

  get size() {
    return this._indexMap.length;
  }

  getObjectAt(index?: number) {
    if (index !== undefined && this._isValidIndex(index)) {
      const mappedIndex = this._indexMap[index];
      const dataObj = this._cache[mappedIndex];
      return dataObj;
    }
    return undefined;
  }
}

export default DataList;
